import React from "react";

import { ThemeProvider } from "@mui/material/styles";

import { THEMES } from "./constants";
import { createThemeMaterialApp } from "./createTheme";

const initialState = {
  theme: THEMES.DEFAULT,
  setTheme: (theme: string) => {},
};
const ThemeContext = React.createContext(initialState);

interface ThemeProviderProps {
  children: React.ReactNode;
}

function MaterialAppThemeProvider({ children }: ThemeProviderProps) {
  const initialState = () => {
    const storedTheme = localStorage.getItem("theme");

    return storedTheme ? JSON.parse(storedTheme) : THEMES.DEFAULT;
  };

  const [theme, _setTheme] = React.useState<string>(initialState());

  const setTheme = (theme: string) => {
    localStorage.setItem("theme", JSON.stringify(theme));
    _setTheme(theme);
  };
  const createdTheme = createThemeMaterialApp(theme);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <ThemeProvider theme={createdTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
}
export { MaterialAppThemeProvider, ThemeContext };
